import { EditorContent } from '@tiptap/react'

import RichTextEditorToolbar from '@components/RichText/RichTextEditorToolbar'

const RichTextEditor = ({ editor, selectorEnabled = false, dateEnabled = false }) => {
  return (
    <>
      <RichTextEditorToolbar editor={editor} selectorEnabled={selectorEnabled} dateEnabled={dateEnabled} />
      <EditorContent editor={editor} />
    </>
  )
}

export default RichTextEditor
